// src/tools/LabelToolHandler.js

import labelLibrary from '../libraries/LabelLibrary';
import layerLibrary from '../canvas/LayerLibrary';
import ProjectManager from '../canvas/ProjectManager';

export default class LabelToolHandler {
  constructor(engine) {
    this.engine = engine;
    this.isTyping = false;
    this.typingLabel = null;
    this.dragOffset = null;
  }

  snapToGrid(value, spacing = 20) {
    return Math.round(value / spacing) * spacing;
  }

  handleMouseDown(e) {
    // const x = (e.offsetX - this.engine.offsetX) / this.engine.scale;
    // const y = (e.offsetY - this.engine.offsetY) / this.engine.scale;
       const rect = this.engine.canvas.getBoundingClientRect();
      const canvasX = e.clientX - rect.left;
      const canvasY = e.clientY - rect.top;

      const x = (canvasX - this.engine.offsetX) / this.engine.scale;
      const y = (canvasY - this.engine.offsetY) / this.engine.scale;

    const snappedX = this.snapToGrid(x, this.engine.gridSpacing);
    const snappedY = this.snapToGrid(y, this.engine.gridSpacing);
  
    const activeLayerId = layerLibrary.getSelectedLayerId();
    const activeLayer = layerLibrary.getLayerById(activeLayerId);
  
    if (!activeLayer) {
      alert("⚠️ Please select a valid layer to place label.");
      return;
    }
  
    // const newLabel = labelLibrary.addLabel(activeLayerId, snappedX, snappedY, '', activeLayer.color);
    const cellName = ProjectManager.getSelectedCell?.();
    const newLabel = labelLibrary.addLabel(cellName, activeLayerId, snappedX, snappedY, '', activeLayer.color);
  
    this.isTyping = true;
    this.typingLabel = newLabel;
  
    this.engine.draw();
  }
  

  handleKeyPress(e) {
    if (!this.isTyping || !this.typingLabel) return;

    if (e.key.length === 1) {
      this.typingLabel.text += e.key;
    } else if (e.key === 'Backspace') {
      this.typingLabel.text = this.typingLabel.text.slice(0, -1);
    } else if (e.key === 'Enter') {
      this.isTyping = false;
      this.typingLabel = null;
    }

    this.engine.draw();
  }

  

  rotateSelectedLabels(degrees) {
    if (!this.engine.selectedLabels?.length) return;
  
    for (let label of this.engine.selectedLabels) {
      label.rotation = ((label.rotation || 0) + degrees) % 360;
    }
  
    this.engine.draw();
  }

  drawBlinkingCursor(ctx, offsetX, offsetY, scale, pointer) {
  if (!pointer) return;

  ctx.save();
  ctx.translate(offsetX, offsetY);
  ctx.scale(scale, scale);

  const caretHeight = 14; // Or dynamically based on label font
  const shouldBlink = Math.floor(Date.now() / 500) % 2 === 0;

  if (shouldBlink) {
    ctx.strokeStyle = "#00ffff";
    ctx.lineWidth = 1 / scale;
    ctx.beginPath();
    ctx.moveTo(pointer.x, pointer.y - caretHeight / 2);
    ctx.lineTo(pointer.x, pointer.y + caretHeight / 2);
    ctx.stroke();
  }

  ctx.restore();
}

  
}
